<template>
    <div class="hts-form-input">
        <div class="flex">
            <hts-form-input
                v-model="cValue.phone"
                class="w-full"
                :label="label"
                :placeholder="placeholder"
                :prop="prop"
                :name="name"
                :disabled="disabled"
                :readonly="readonly"
                :required="required"
                emit-error
                has-prefix-input>
                <template #prefixInput>
                    <hts-form-select
                        v-model="cValue.countryCode"
                        class="w-24"
                        :items="items"
                        :required="required"
                        :text="cValue.code"
                        :readonly="locked"
                        :clearable="false"
                        :limit-items="1000"
                        label-only-show-text
                        emit-error />
                </template>
            </hts-form-input>
        </div>
    </div>
</template>

<script setup lang="ts">
import countryCodes from '@/data/country-code/index.json'
const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {
      return {
        countryCode: '',
        phone: '',
        code: ''
      }
    }
  },
  label: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  prop: {
    type: String,
    default: 'phone'
  },
  name: {
    type: String,
    default: 'phone'
  },
  disabled: Boolean,
  readonly: Boolean
})

const { modelValue, disabled, readonly } = toRefs(props)

const emits = defineEmits(['update:modelValue', 'updateCode'])

const cValue = computed({
  get () {
    return modelValue?.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const locked = computed(() => disabled.value || readonly.value)
const items = computed(() => {
  const values = countryCodes
    .map((countryCode) => {
      return {
        value: `${countryCode.country} ${countryCode.code}`,
        label: `${countryCode.country} ${countryCode.code}`,
        code: countryCode.code
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label))

  return [
    ...values.filter((item) => item.value === 'Vietnam +84'),
    ...values.filter((item) => item.value === 'Cambodia +855'),
    ...values.filter((item) => !['Vietnam +84', 'Cambodia +855'].includes(item.value))
  ]
})

watch(
  () => cValue.value.countryCode,
  (val) => {
    updateCode(val)
  }
)

onMounted(() => {
  updateCode(cValue.value.countryCode)
})

const updateCode = (countryCode: string) => {
  if (!countryCode) {
    cValue.value.code = ''
    emits('updateCode', '')
    return
  }
  items.value.forEach((item) => {
    if (item.value === countryCode) {
      cValue.value.code = item.code
      emits('updateCode', item.code)
    }
  })
}
</script>
